<template>
  <router-view/>
</template>

<script>
export default {
  name: "DefaultLayout.vue"
}
</script>